document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('form#cart');
  const vat  = document.querySelector('#cart-attributes-vat');
  if (!form || !vat) return;               // field not present (e.g. non-B2B)

  form.addEventListener('submit', (e) => {
    const v = vat.value.trim();

    // — simplest rule: must not be empty —
    if (v === '') {
      e.preventDefault();
      alert('Please enter your VAT number.');
      vat.focus();
      return;
    }

    /* — optional stricter EU-style pattern —
       const regex = /^[A-Z]{2}[A-Z0-9]{8,12}$/;
       if (!regex.test(v)) {
         e.preventDefault();
         alert('Please enter a valid VAT number, e.g. NL123456789B01');
         vat.focus();
       }
    */
  });
});
